import { Component, OnInit } from '@angular/core';

declare let require: any;
@Component({
  selector: 'app-npc-root',
  templateUrl: './npc-root.component.html',
  styleUrls: ['./npc-root.component.css'],
  standalone: false
})
export class NpcRootComponent implements OnInit {

  cbUrl = 'https://bigfuture.collegeboard.org/pay-for-college/paying-your-share/focus-on-net-price-not-sticker-price';

  ngOnInit() {
    try {
      require('../../_services/adobe404.js');
    } catch (error) {
      console.log(error);
    }

    setTimeout(() => {
      window.location.href = this.cbUrl;
    }, 8000);  // 8s

  }

}



